import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '../ui/switch';
import { notificationsAPI, errMsg } from '../../lib/communicationsAPI';

// Per-user notification preferences (in-app / email) — used in Settings > Communications.
export const NotificationPrefs = () => {
  const [types, setTypes] = useState(null);
  useEffect(() => { notificationsAPI.prefs().then((r) => setTypes(r.data.types)).catch(() => setTypes([])); }, []);
  const toggle = async (key, field, v) => {
    try { const r = await notificationsAPI.savePrefs({ [key]: { [field]: v } }); setTypes(r.data.types); toast.success('Preferences saved'); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!types) return <Loader2 className="w-5 h-5 animate-spin" />;
  return (
    <div className="space-y-1" data-testid="notification-prefs">
      <div className="grid grid-cols-[1fr_72px_72px] text-[11px] uppercase tracking-wide text-muted-foreground px-1"><span>Notification</span><span className="text-center">In-app</span><span className="text-center">Email</span></div>
      {types.map((t) => (
        <div key={t.key} className="grid grid-cols-[1fr_72px_72px] items-center py-2.5 px-1 border-t border-border text-sm">
          <span>{t.label}</span>
          <span className="flex justify-center"><Switch checked={t.in_app} onCheckedChange={(v) => toggle(t.key, 'in_app', v)} data-testid={`notif-pref-${t.key}-in_app`} aria-label={`${t.label} in-app`} /></span>
          <span className="flex justify-center"><Switch checked={t.email} onCheckedChange={(v) => toggle(t.key, 'email', v)} data-testid={`notif-pref-${t.key}-email`} aria-label={`${t.label} email`} /></span>
        </div>
      ))}
      <p className="text-xs text-muted-foreground pt-2">Emails never include message content — only a nudge to log in. Mailboxes are managed by owners/admins below.</p>
    </div>
  );
};
